export default __webpack_public_path__ + "static/media/app-icon-cian.da3ee636.svg";